<template>
    <b-row
            class="ae--container"
            no-gutters
    >
        <b-col cols="3" class="overflow-hidden p-1">
            <div class="bg-whitesmoke h-100">
                <b-card
                        v-if="$slots['top-left']"
                        class="wr-card wr-top-left"
                >
                    <slot name="top-left"/>
                </b-card>
                <b-card
                        v-if="$slots['middle-left']"
                        class="wr-card wr-middle-left p-0"
                >
                    <slot name="middle-left"/>
                </b-card>
                <b-card
                        v-if="$slots['bottom-left']"
                        class="wr-card wr-bottom-left"
                >
                    <slot name="bottom-left"/>
                </b-card>
            </div>
        </b-col>
        <b-col cols="6" class="overflow-hidden p-1">
            <div class="h-100">
                <slot name="center"/>
            </div>
        </b-col>
        <b-col cols="3" class="overflow-hidden p-1">
            <div class="bg-whitesmoke h-100">
                <b-card
                        v-if="$slots['top-right']"
                        class="wr-card wr-top-right"
                >
                    <slot name="top-right"/>
                </b-card>
                <b-card
                        v-if="$slots['bottom-right']"
                        class="wr-card wr-bottom-right br-3"
                >
                    <slot name="bottom-right"/>
                </b-card>
            </div>
        </b-col>
    </b-row>
</template>
<script>
    export default {
        name: 'ae-container'
    }
</script>
